import { Injectable } from '@angular/core';
declare const swal: any;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  showSuccess(message: string = 'Operation successful', title: string = ''): void {
    swal({
      title: title,
      text: message,
      type: 'success',
      confirmButtonClass: 'btn btn-info',
    });
  }

  showError(message: string = 'Something went wrong', title: string = ''): void {
    swal({
      title: title,
      text: message,
      type: 'error',
      confirmButtonClass: 'btn btn-info',
    });
  }

  showWarning(message: string, title: string = ''): void {
    swal({
      title: title,
      text: message,
      type: 'warning',
      confirmButtonClass: 'btn btn-warning',
    });
  }
   
}
